<template>
    <section class="people-wrap">
        <div class="people-title">
            <div class="title-name" v-for="(item, index) in title" :key="index">
                {{ item }}
            </div>
        </div>
        <div class="people-list">
            <div class="people-scroll">
                <van-pull-refresh
                    v-model="refreshing"
                    @refresh="onRefresh"
                    :pulling-text="$t('Refresh_after_release')"
                    :loosing-text="$t('Refresh_after_release')"
                    :loading-text="$t('Loading_please_wait')"
                >
                    <van-list
                        v-model:loading="list.loading"
                        :finished="list.finished"
                        :loading-text="$t('Loading_please_wait')"
                        :finished-text="$t('No_more')"
                        @load="onLoad"
                    >
                        <div class="list-item" v-for="(item, index) in list.data" :key="index">
                            <div class="list-left">
                                <div :class="['list-avatar', { active: type === 1 }]" @click="goChat(item)"><img :src="item._source.avatar" /></div>
                                <div class="list-id">
                                    <p :class="['id', { active: type === 0 && item._source.isCopartner }]">
                                        ID:{{ item._source?.uid || item._source.context.uid }}
                                    </p>
                                    <p class="list-name elipsis">{{ decodeName(item._source.nickname) }}</p>
                                </div>
                            </div>
                            <div class="list-time">
                                {{
                                    type === 0
                                        ? dayjs(item._source?.time || item._source.context.time).format('YYYY.MM.DD')
                                        : (item._source.rate * 100).toFixed(2) + '%'
                                }}
                            </div>
                            <div
                                :class="[
                                    'list-setup',
                                    {
                                        active:
                                            store.partnerInfo?.level != 999 &&
                                            ((type === 0 && item._source.isCopartner) ||
                                                (type === 0 && store.partnerInfo?.level <= 1) ||
                                                (type === 1 && store.partnerInfo?.level <= 1)),
                                    },
                                ]"
                                @click="handleSetShow(item, index)"
                            ></div>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </div>
        </div>
    </section>
    <PartnerSet v-model="showSet" :info="info" :type="type" :index="idx" @success="handleSuccess" />
</template>
<script setup lang="ts">
import PartnerSet from '@/components/common/partnerSet.vue'
import { usePagation } from '@/hooks/usePagation'
import { getPartnerInvite, getCopartnerSubList } from '@/api/partner'
import { decodeName } from '@/utils'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import { useBaseStore } from '@/stores'
import { useI18n } from 'vue-i18n'

const props = defineProps({
    type: {
        type: Number,
        default: () => 0,
    },
    title: {
        type: Array,
        default: () => [],
    },
})
const { list, start } = usePagation()
const router = useRouter()
const store = useBaseStore()
const i18n = useI18n()
const showSet = ref(false)
const info = ref({})
const idx = ref(0)
const refreshing = ref(false)
const handleSetShow = (item, index) => {
    if (props.type === 0 && item._source.invited) {
        return store.showFailToast(i18n.t('copartner_player_set10'))
    }
    info.value = item
    idx.value = index
    showSet.value = true
}

const getInvite = async (id) => {
    list.loading = true
    try {
        const getData = props.type === 1 ? getCopartnerSubList : getPartnerInvite
        let params = { from: start.value, size: list.pageSize }
        if (props.type === 0 && id) {
            params = {
                ...params,
                // @ts-ignore
                id: +id,
            }
        }
        const res = await getData(params)
        if (res.code === 200) {
            const newList = res.data
            if (newList.length < list.pageSize) {
                list.finished = true
            }
            list.data = list.pageNum === 1 ? [...newList] : [...list.data, ...newList]
        }
    } finally {
        list.loading = false
        list.pageNum++
        if (refreshing.value) {
            refreshing.value = false
        }
    }
}
const handleSuccess = (data) => {
    const { num, index } = data
    const item = list.data[index]
    item._source.rate = num
    list.data[index] = { ...item }
}
const onLoad = async () => {
    list.loading = true
    await getInvite('')
}
const handleSearch = async (val) => {
    list.finished = false
    list.pageNum = 1
    await getInvite(val)
}
const onRefresh = () => {
    list.finished = false
    list.pageNum = 1
    onLoad()
}

const goChat = (item) => {
    if (props.type !== 1) {
        return
    }
    store.$patch((state) => {
        state.unReadCount[item.channel] = 0
    })
    router.push({
        path: '/chat',
        query: {
            nickname: decodeName(item._source.nickname),
            userID: item._source.uid,
            isRs: Number(item._source.reseller),
        },
    })
}
defineExpose({
    handleSearch,
    list,
})
onMounted(() => {
    store.getPartnerInfo()
})
</script>
<style lang="scss" scoped>
.people-wrap {
    padding: 6px 6px 0;
    font-family: MicrosoftYaHei;
    color: #ffffff;
    background-color: #000000;
    border-radius: 30px 30px 0px 0px;
    height: calc(100% - var(--search-height));

    $titleHeight: 80px;

    .people-title {
        @apply flex items-center;
        height: $titleHeight;
        background-color: #6c3566;
        border-radius: 24px 24px 0px 0px;

        .title-name {
            font-size: 26px;
            color: #b180aa;

            &:nth-child(1) {
                padding-left: 30px;
                width: 54%;
            }
            &:nth-child(1) {
                width: 54%;
            }
        }
    }
    .people-list {
        padding: 10px 4px 0;
        height: calc(100% - $titleHeight);

        .people-scroll {
            height: 100%;
            overflow-y: scroll;
        }
    }
    .list-item {
        @apply flex items-center;
        margin-bottom: 10px;
        height: 120px;
        background-image: linear-gradient(#40274e, #40274e), linear-gradient(#333333, #333333);
        background-blend-mode: normal, normal;
        border-radius: 20px;
        border: solid 3px #553669;
        font-size: 24px;

        .list-left {
            @apply flex items-center;
            padding-left: 30px;
            width: 54%;

            .list-avatar {
                position: relative;
                margin-right: 24px;
                border-radius: 50%;
                width: 84px;
                height: 84px;
                border: solid 4px #553669;
                // overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
                &.active {
                    &::after {
                        position: absolute;
                        right: -10px;
                        bottom: -2px;
                        content: '';
                        width: 36px;
                        height: 36px;
                        background: url('@/assets/img/people-list/msg.png') no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
            .list-id {
                width: calc(100% - 118px);

                .list-name {
                    color: #b88dcb;
                }
                .id {
                    @apply flex;

                    &.active {
                        &::after {
                            display: inline-block;
                            content: '';
                            margin-left: 9px;
                            width: 32px;
                            height: 32px;
                            background: url('@/assets/img/people-list/partner.png') no-repeat center center;
                            background-size: 100% 100%;
                        }
                    }
                }
            }
        }
        .list-time {
            flex: 1;
        }
        .list-setup {
            width: 88px;
            height: 48px;
            background: url('@/assets/img/people-list/setup.png') no-repeat center center;
            background-size: 48px 48px;
            &.active {
                opacity: 0;
                pointer-events: none;
            }
        }
    }
}
:deep(.van-pull-refresh) {
    min-height: 800px;
    .van-list {
        min-height: 100%;
    }
}
</style>
